/**
 *@param {Object} obj {url: '图片地址(必填),width: '图片宽度(选填)', height: '图片高度(选**填)'}
 */
function getImg(obj, callback) {
  return new Promise((resolve, reject) => {
    const _canvas = document.createElement("canvas");
    _canvas.id = "drawImg";
    _canvas.style.display = "none";
    document.body.appendChild(_canvas);
    const canvasImage = document.getElementById("drawImg");
    const ctx2 = canvasImage.getContext("2d");
    const img = document.createElement("img");

    canvasImage.width = obj.width;
    canvasImage.height = obj.height;

    if (!obj && !obj.url) {
      console.error("obj.url is undefined");
      return;
    }

    img.src = obj.url;
    img.id = "drawImgContainer";
    img.style.display = "none";
    document.body.appendChild(img);

    const _i = document.getElementById("drawImgContainer");
    //监听图片load事件，图片加载完成获取当前图片地址(base64格式)
    //不等图片加载完成获取图片会失败
    _i.onload = function () {
      ctx2.drawImage(_i, 0, 0, canvasImage.width, canvasImage.height);
      document.body.removeChild(_i);
      const imgBase64Code = canvasImage.toDataURL("image/jpeg");
      document.body.removeChild(_canvas);
      resolve(imgBase64Code);
    };
    _i.onerror = function (err) {
      reject(null);
    };
  });
}

export default getImg;
